import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import uploadViewStateToProps from "../selectors";
import * as actions from "../actions";
import UploadLayout from "./UploadLayout";

class UploadView extends React.Component {
  static propTypes = {
    actions: PropTypes.shape({
      uploadFiles: PropTypes.func.isRequired
    }).isRequired
  };

  componentDidMount() {
    document.title = "CTD Upload";
  }

  handleFilesDrop(files) {
    this.props.actions.uploadFiles(files);
  }

  render() {
    return (
      <UploadLayout
        {...this.props}
        onFilesDrop={files => this.handleFilesDrop(files)}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(
    uploadViewStateToProps,
    mapDispatchToProps
  )(UploadView)
);
